module.exports = __webpack_public_path__ + "img/year-in-pixels.7f1b04bc.jpg";